import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface SavvyPage {
  savvy_id: string;
}

interface SavvyLoggedOutHomepage {
  value: boolean;
}

export const savvyPage: Module<SavvyPage, RootState> = {
  namespaced: true,
  state: {
    savvy_id: '',
  },
  getters: {
    savvyId: (state: SavvyPage): string => state.savvy_id,
  },
  mutations: {
    setValue(state: SavvyPage, value: SavvyPage): void {
      Object.assign(state, value);
    },
  },
};

export const savvyLoggedOutHomepage: Module<SavvyLoggedOutHomepage, RootState> = {
  namespaced: true,
  state: {
    value: false,
  },
  getters: {
    savvyEnabledLoggedOutHomepage: (state: SavvyLoggedOutHomepage): boolean => state.value,
  },
  mutations: {
    setValue(state: SavvyLoggedOutHomepage, value: SavvyLoggedOutHomepage): void {
      Object.assign(state, value);
    },
  },
};
